import { AnalyticsTypes } from '../../middleware/google-analytics';
import * as TrackingConstants from '../../EventTrackingConstants';

export const ActionTypes = {
    TOGGLE_LOCATION_EXPANDED: '@@locations/TOGGLE_LOCATION_EXPANDED',
    TRACK_CLICK_EXPAND_MAP: '@@locations/TRACK_CLICK_EXPAND_MAP',
};

export const toggleLocationExpanded = locationId => ({
    type: ActionTypes.TOGGLE_LOCATION_EXPANDED,
    locationId,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Location Card View More Info',
            data: {
                Component: TrackingConstants.TARGETS.LOCATION_CARD,
                Element: TrackingConstants.TARGETS.VIEW_MORE_INFO,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.LOCATION_LIST,
                EventAction: 'click view more info',
                EventDetails: { LocationId: locationId },
            },
        },
    },
});

export const trackClickExpandMap = locationId => ({
    type: ActionTypes.TRACK_CLICK_EXPAND_MAP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Location Card Map',
            data: {
                Component: TrackingConstants.TARGETS.LOCATION_CARD,
                Element: TrackingConstants.TARGETS.MAP,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.LOCATION_LIST,
                EventAction: 'click map',
                EventDetails: { LocationId: locationId },
            },
        },
    },
});
